/** 现场实操任务相关类型 */

/** 任务类型 */
export enum TaskType {
  SCAN_BIND_IOT = 'SCAN_BIND_IOT',
  LOADING_SEAL = 'LOADING_SEAL',
  NODE_INSPECTION = 'NODE_INSPECTION',
  SIGN_UNBOX = 'SIGN_UNBOX',
}

/** 任务状态 */
export enum TaskStatus {
  TODO = 'TODO',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  OVERDUE = 'OVERDUE',
}

/** 任务优先级 */
export enum TaskPriority {
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  HIGH = 'HIGH',
  URGENT = 'URGENT',
}

/** 检查项 */
export interface ChecklistItem {
  id: string;
  label: string;
  required: boolean;
  completed: boolean;
  photoRequired: boolean;
}

/** 现场任务 */
export interface FieldTask {
  id: string;
  taskNo: string;
  type: TaskType;
  containerNo: string;
  nodeId: number;
  nodeName: string;
  assignedTo: string;
  status: TaskStatus;
  priority: TaskPriority;
  deadline: string;
  createdAt: string;
  checklist: ChecklistItem[];
  location: string;
}
